import FastImage from "../../../globals/elements/fastimg"
import { NavLink } from "react-router-dom"
import { route } from "../../../globals/constants"

export default function GoodCard({item, className}) {
    return (
        <div className={className}>
            <div className="mt-box mt-product-box bdr-1 bdr-solid bdr-gray-light">
                <div className="mt-thum-bx mt-img-overlay4 mt-img-effect zoom">
                    <FastImage src={item?.img} alt="" />
                    <div className="overlay-bx">
                        <div className="overlay-icon">
                            <NavLink className="mfp-link" to={`${route.shop.DETAIL}/${item?.id}`} title="wish list">
                                <i className="fa fa-heart mt-icon-box-xs" />
                            </NavLink>
                            
                            {/* <NavLink to={route.shop.CART} title="Add to cart">
                                <i className="fa fa-cart-plus mt-icon-box-xs" />
                            </NavLink> */}
                        </div>
                    </div>
                </div>
                <div className="mt-info  text-center">
                    <div className="p-a10">
                        <h4 className="mt-title">
                            <NavLink to={`${route.shop.DETAIL}/${item?.id}`}>{item?.title}</NavLink>
                        </h4>
                        {/* <span className="price">
                            <ins>
                                <span><span className="Price-currencySymbol">$ </span>49.00</span>
                            </ins>
                        </span>
                        <div className="p-tb15">
                            <button className="site-button" type="button">Buy Now</button>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}